export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            initOnRender: false,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "companyName",
                label: "Partner neve",
                visibility: true
            },
            {
                name: "patientName",
                label: "Páciens neve",
                visibility: true
            },
            {
                name: "patientSex",
                label: "Nem",
                visibility: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ szám",
                visibility: true
            },
            {
                name: "dateOfBirth",
                label: "Szül. dátum",
                slot_name: "date_format",
                formSize: 3,
                formType: "date",
                visibility: true
            },
            {
                name: "employeeId",
                label: "Törzsszám",
                visibility: true
            },
            {
                name: "patientEmail",
                label: "Email cím",
                visibility: true
            },
            {
                name: "hierarchy",
                label: "Cég struktúra",
                visibility: true
            },
            {
                name: "siteGroupName",
                label: "Munkakör",
                visibility: true
            },
            {
                name: "isActive",
                label: "Aktív ebben a munkakörben",
                visibility: true
            },
            {
                name: "feorCode",
                label: "FEOR kód",
                visibility: true
            },
            {
                name: "jobCategory",
                label: "FEÜ kategória",
                visibility: true
            },
            {
                name: "restrictionText",
                label: "Korlátozás",
                visibility: true,
                formVisible: true,
                formSize: 6,
            },
            {
                name: "customRestriction",
                label: "Egyéni korlátozás",
                visibility: true,
                formVisible: true,
                formSize: 6,
                formType: "textarea"
            },
            {
                name: "employabilityType",
                label: "Vizsgálat típusa",
                visibility: true
            },
            {
                name: "capableStatus",
                label: "Eredmény",
                visibility: true
            },
            {
                name: "note",
                label: "Megjegyzés",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Keltezés dátuma",
                visibility: true
            },
            {
                name: "validity",
                label: "Érvényesség",
                visibility: true
            },
            {
                name: "isValid",
                label: "Érvényes",
                visibility: true
            },
            // {
            //     name: "clinicSiteName",
            //     label: "Ellátóhely",
            //     visibility: true
            // },
            // {
            //     name: "partnerHierarchy",
            //     label: "Cég struktúra",
            //     visibility: true
            // },
            // {
            //     name: "feorCode",
            //     label: "FEOR kód",
            //     visibility: true
            // },
            // {
            //     name: "jobTitle",
            //     label: "Munkakör",
            //     visibility: true
            // },
            // {
            //     name: "employeeId",
            //     label: "Törzsszám",
            //     formSize: 3,
            //     formType: "text"
            // },
            // {
            //     name: "statusName",
            //     label: "Státusz",
            //     formSize: 3,
            //     formType: "text"
            // },
            // {
            //     name: "name",
            //     label: "Páciens neve",
            //     visibility: true
            // },
            // {
            //     name: "employeeGender",
            //     label: "Munkavállaló neme",
            //     visibility: true
            // },
            // {
            //     name: "socialInsuranceNumber",
            //     label: "TAJ szám",
            //     visibility: true
            // },
            // {
            //     name: "dateOfBirth",
            //     label: "Szül. dátum",
            //     slot_name: "date_format",
            //     formSize: 3,
            //     formType: "date"
            // }, 
            // {
            //     name: "email",
            //     label: "Páciens email címe",
            //     visibility: true
            // },
            // {
            //     name: "jobCategory",
            //     label: "FEÜ kategória",
            //     visibility: true
            // },
            // {
            //     name: "doctorName",
            //     label: "Vizsgáló orvos",
            //     formSize: 3,
            //     formType: "text",
            //     visibility: true
            // },
            // {
            //     name: "visitType",
            //     label: "Vizsgálat típusa",
            //     visibility: true
            // },
            // {
            //     name: "visitCategoryTypeId",
            //     label: "Vizsgálati csoport",
            //     formType: "text",
            //     formSize: 3,
            // },
            // {
            //     name: "result",
            //     label: "Eredmény",
            //     visibility: true
            // },
            // {
            //     name: "employabilityCreatedOn",
            //     label: "Dokumentum keletkezés időpontja",
            //     slot_name: "employability_created_on_format",
            //     visibility: true,
            // },
            // {
            //     name: "visitDate",
            //     label: "Vizsgálat időpontja",
            //     slot_name: "appointment_format",
            //     visibility: true,
            // },
            // {
            //     name: "validTo",
            //     label: "Érvényesség vége",
            //     slot_name: "isThisTheActualDate",
            //     visibility: true
            // },
            // {
            //     name: "restrictionText",
            //     label: "Korlátozások",
            //     visibility: true,
            //     formVisible: true,
            //     formSize: 6,
            // },
            // {
            //     name: "customRestriction",
            //     label: "Egyéni korlátozások",
            //     visibility: true,
            //     formVisible: true,
            //     formSize: 6,
            //     formType: "textarea"
            // },
            // {
            //     name: "isConnectedToManager",
            //     label: "Menedzser",
            //     formType: "checkbox",
            //     formSize: 4,
            //     formVisible: true,
            //     visibility: true,
            //     slot_name: "isConnectedToManagerFormat"
            // },
        ]
    }
}
